import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global error handling to catch "Script error." and other runtime issues
window.addEventListener('error', (event) => {
  console.error('[Global Error]', event.error || event.message);
  if (event.message === 'Script error.') {
    console.warn('Cross-origin script error detected. Consider checking CDN or external script origins.');
  }
});

window.addEventListener('unhandledrejection', (event) => {
  // Always prevent default to avoid annoying Vite error overlay in the UI
  event.preventDefault(); 
  
  const payload = event.reason;
  // If it's a fetch crash due to server reloading etc, keep it quiet
  if (payload?.name === 'TypeError' && typeof payload?.message === 'string' && payload.message.includes('fetch')) {
      console.warn("Ignored fetch unhandled rejection (likely DevServer reloading):", payload);
  } else {
      console.error('[Unhandled Rejection]', payload);
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
